// extracted by mini-css-extract-plugin
export var fullWidthButton = "_eb-0";